import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import ID from "./ID"

const Container = styled(Link)`
  flex: none;
  white-space: nowrap;
  &:link {
    text-decoration: none;
  }
`

const Icon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colours.text.tertiary};
  margin-left: 0.5rem;
`

const IDLink = ({ to, showLinkIcon = true, children }) => {
  return (
    <Container to={to}>
      <ID>{children}</ID>
      {showLinkIcon && <Icon icon={faUpRightFromSquare} />}
    </Container>
  )
}

IDLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.any,
  showLinkIcon: PropTypes.bool,
}

export default IDLink
